import { api } from "@/lib/axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CompanyInfoParams, SeCompany } from "@/interface/setting/se_company";
import { toast } from "sonner";

const companyInfoQueryKey = "companyInfo";

export const useCompanyInfo = (params: CompanyInfoParams) => {
  const { page = 0, size = 20, search = "", sort = "id,desc" } = params;

  return useQuery<SeCompany[]>({
    queryKey: [companyInfoQueryKey, params],
    queryFn: async () => {
      const response = await api.get("/company-setting", {
        params: {
          page,
          size,
          sort,
        },
      });
      return response.data.content;
    },
  });
};

export const useCompanyInfoSearch = (search: string) => {
  return useMutation({
    mutationFn: async () => {
      const response = await api.post("/company-setting/search", null, { params: { companyName: search } });
      return response.data;
    },
    onSuccess: res => {
      // console.log(res);
    },
    onError: err => {
      console.error(err);
    },
  });
};

export const useCompanyInfoDetail = (id: number) => {
  return useMutation({
    mutationFn: async (id: number) => {
      const response = await api.post("/company-setting/detail", null, { params: { id } });
      return response.data;
    },
    onSuccess: res => {
      console.log(res);
    },
  });
};

export const useCompanyInfoSave = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SeCompany) => {
      const response = await api.post("/company-setting", data);
      return response.data;
    },
    onSuccess: res => {
      console.log(res);
      // companyInfo 쿼리 캐시 무효화 (모든 params 조합)
      queryClient.invalidateQueries({
        queryKey: [companyInfoQueryKey],
        exact: false,
      });
    },
    onError: err => {
      console.error(err);
    },
  });
};

export const useCompanyInfoUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: number; data: SeCompany }) => {
      const response = await api.put(`/company-setting/${id}`, data);
      return response.data;
    },
    onSuccess: res => {
      console.log(res);
      // companyInfo 쿼리 캐시 무효화 (모든 params 조합)
      queryClient.invalidateQueries({
        queryKey: [companyInfoQueryKey],
        exact: false,
      });
    },
    onError: err => {
      console.error(err);
    },
  });
};

export const useCompanyInfoDelete = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const response = await api.delete(`/company-setting`, { params: { id } });
      return response.data;
    },
    onSuccess: res => {
      console.log(res);
      toast.success("회사 기본 정보 삭제 성공");
      queryClient.invalidateQueries({
        queryKey: [companyInfoQueryKey],
        exact: false,
      });
    },
    onError: err => {
      console.error(err);
      toast.error("회사 기본 정보 삭제 실패");
    },
  });
};
